export default __webpack_public_path__ + "static/media/stock.cbc6bb39.png";